import {charcoal} from '../../sass/v2/_exports.sass';

export const AddLinkIcon = ({color = charcoal, className = '', ratio = 1}) => {
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};
  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Add link</title>
      <path
        d="M14.4103 22.0513H9.38466C7.71043 22.0513 6.28333 21.4613 5.10333 20.2813C3.92333 19.1016 3.33333 17.6747 3.33333 16.0007C3.33333 14.3267 3.92333 12.8996 5.10333 11.7194C6.28333 10.5389 7.71043 9.94873 9.38466 9.94873H14.4103V11.9487H9.38466C8.26489 11.9487 7.30977 12.3441 6.51933 13.1347C5.72866 13.9253 5.33333 14.8805 5.33333 16C5.33333 17.1196 5.72866 18.0747 6.51933 18.8653C7.30977 19.656 8.26489 20.0513 9.38466 20.0513H14.4103V22.0513ZM11 17V15H21V17H11ZM17.5897 22.0513V20.0513H22.6153C23.7351 20.0513 24.6903 19.656 25.4807 18.8653C26.2713 18.0747 26.6667 17.1196 26.6667 16C26.6667 14.8805 26.2713 13.9253 25.4807 13.1347C24.6903 12.3441 23.7351 11.9487 22.6153 11.9487H17.5897V9.94873H22.6153C24.2896 9.94873 25.7167 10.5387 26.8967 11.7187C28.0767 12.8985 28.6667 14.3253 28.6667 15.9993C28.6667 17.6733 28.0767 19.1005 26.8967 20.2807C25.7167 21.4612 24.2896 22.0513 22.6153 22.0513H17.5897Z"
        fill={color}
      />
    </svg>
  );
};
